module.exports = __webpack_public_path__ + "img/43_30.90348ac9.png";